import http from '@/communication/AuthConnection'
export default async ({ commit }, { eventId, documentId, fileType }) => {
  try {
    const params = {
      eventId
    }
    const { status, data } = await http.get(`/v1/documents/view/${documentId}`, {
      params
    }, {
      responseType: 'blob',
      headers: {
        'Content-type': 'multipart/form-data'
      }
    })
    if (status !== 200) {
      throw Error('Não conseguimos baixar o arquivo')
    }
    return {
      data: data.fileLink,
      fileName: data.fileName
    }
  } catch (error) {
    return Promise.reject(error)
  }
}



// WEBPACK FOOTER //
// ./src/brain/event-documents/ViewDocument.js